import api from 'api';

export const loadDefaultApplications = api(
  'GET /api/marketing-planning/default/applications'
);

export const loadDefaultChannels = api(
  'GET /api/marketing-planning/default/channels'
);

export const loadDefaultPlatforms = api(
  'GET /api/marketing-planning/default/platforms'
);

export const loadDefaultAffiliates = api(
  'GET /api/marketing-planning/default/affiliates'
);

export const loadDefaultCountries = api(
  'GET /api/marketing-planning/default/countries'
);

export const loadDefaultManagers = api(
  'GET /api/marketing-planning/default/managers'
);

export const loadDefaultOwners = api(
  'GET /api/marketing-planning/default/owners'
);
